import xss from 'xss';

export const purify = (input?: string | null) => {
  const options = {
    // eslint-disable-next-line @spotify/best-practices/no-discouraged-words
    whiteList: {
      a: ['class', 'style', 'href'],
      b: [], // deprecated, for retro compatibility only (use strong)
      br: [],
      div: ['class', 'style'], // deprecated, for retro compatibility only
      em: [],
      i: [], // deprecated, for retro compatibility only (use em)
      li: [],
      ol: [],
      p: [],
      span: ['class', 'style'], // deprecated, for retro compatibility only
      strong: [],
      sup: [],
      ul: [],
    },
  };

  return typeof input !== 'string' ? '' : xss(input, options);
};
